import { ModalView } from '@/design-system/components/modal/ModalView';
import { UniNativeModal } from '@/design-system/components/modal/nativeModal/UniNativeModal';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { getObjectScreenNameFromPath, popStateLockedMap } from '@/design-system/components/navigatorEmbed/UtxAppNavigatorEmbed';
import { useFocusEffect } from '@react-navigation/native';
import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View } from 'dripsy';
import * as DocumentPicker from 'expo-document-picker';
import React, { useCallback, useContext } from 'react';
import { Platform } from 'react-native';
import BillPaymentApp from '../..';
import { PAYMENT_TYPE, QuoteDataRequest, QuoteResponse } from '../../hooks/useCreateBillPayment.hook';
import { BillPaymentStackRoutes } from '../../payment.navigator';
import { mapUrlLink } from '../../utils/utils';
import { BillPaymentConfirmationWeb } from './BillPaymentConfirmation.desktop.component';
import { BillPaymentConfirmationMobile } from './BillPaymentConfirmationMobile.component';
import { BillPaymentConfirmationStackRoutes, BillPaymentConfirmationStackScreenProps } from './type';

export interface BillPaymentModalProps {
  request: QuoteDataRequest;
  response: QuoteResponse;
  onResult: () => void;
  debitAccount: string;
  flagUploaded?: boolean;
  documentSelected?: DocumentPicker.DocumentResult;
  paymentType: PAYMENT_TYPE;
}

export const BillPaymentConfirmationModal: React.FC<
  BillPaymentConfirmationStackScreenProps<BillPaymentConfirmationStackRoutes.BillPaymentConfirm>
> = ({ navigation, route }) => {
  const { request, response, debitAccount, flagUploaded, documentSelected, paymentType } = route.params;
  const layout = useContext(LayoutContext);

  const onGoBack = () => {
    if (Platform.OS === 'web') {
      popStateLockedMap.set('popstate', true);
      navigation.goBack();
      setTimeout(() => popStateLockedMap.set('popstate', false), 500);
    } else {
      navigation.goBack();
    }
  };

  useFocusEffect(
    useCallback(() => {
      if (Platform.OS === 'web') {
        const onPopState = (event: any) => {
          window.history.pushState(event.state, '');
          setTimeout(() => {
            const popStateLocked = popStateLockedMap.get('popstate') ?? false;
            if (!document.location.href || popStateLocked) return;
            const { parentName, subName } = mapUrlLink(document.location.href);
            var screenNameObject = getObjectScreenNameFromPath([BillPaymentApp], `/${subName}`);
            if (
              screenNameObject.screenName &&
              screenNameObject.routeStackName === parentName &&
              screenNameObject.screenName === BillPaymentStackRoutes.Confirmation
            ) {
              onGoBack();
            }
          }, 200);
        };
        window.addEventListener('popstate', onPopState);
        return () => {
          window.removeEventListener('popstate', onPopState);
        };
      }
    }, [])
  );

  if (layout.isMobile) {
    return (
      <View sx={stylesNative.containerNative}>
        <UniNativeModal onBack={onGoBack} showHeader={false}>
          <BillPaymentConfirmationMobile onClose={onGoBack} />
        </UniNativeModal>
      </View>
    );
  }
  const { useModalProps } = useModalView({});
  return (
    <ModalView useModalProps={useModalProps} minWidth={850}>
      <BillPaymentConfirmationWeb
        onClose={() => {
          onGoBack();
        }}
        request={request}
        flagUploaded={flagUploaded}
        response={response}
        debitAccount={debitAccount}
        documentSelected={documentSelected}
        paymentType={paymentType}
      />
    </ModalView>
  );
};

enum StyleNameNative {
  containerNative = 'containerNative'
}

const stylesNative: Record<StyleNameNative, SxProp> = {
  containerNative: {
    flex: 1,
    height: '100%',
    backgroundColor: 'transparent'
  }
};
